var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContent"},[_c('p',[_vm._v(_vm._s(_vm.contents))]),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"submit",on:{"click":_vm.cancel}},[_vm._v(_vm._s(this.$t('popup-submit')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2507eb68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popupElements/Alert.vue
// module id = 203
// module chunks = 1